type SFXName = "select" | "reroll" | "teamComplete" | "hover" | "click";

class AudioManager {
  private audioContext: AudioContext | null = null;
  private musicElement: HTMLAudioElement | null = null;
  private sfxEnabled = true;
  private musicEnabled = false;
  private sfxBuffers: Map<SFXName, AudioBuffer> = new Map();

  private getContext(): AudioContext {
    if (!this.audioContext) {
      this.audioContext = new AudioContext();
    }
    return this.audioContext;
  }

  async loadSFX(name: SFXName, url: string): Promise<void> {
    try {
      const response = await fetch(url);
      const buffer = await response.arrayBuffer();
      const audioBuffer = await this.getContext().decodeAudioData(buffer);
      this.sfxBuffers.set(name, audioBuffer);
    } catch { /* SFX loading is best-effort */ }
  }

  playSFX(name: SFXName): void {
    if (!this.sfxEnabled) return;
    const buffer = this.sfxBuffers.get(name);
    if (!buffer) return;
    try {
      const ctx = this.getContext();
      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
    } catch { /* Audio playback is best-effort */ }
  }

  setMusic(url: string): void {
    if (this.musicElement) this.musicElement.pause();
    this.musicElement = new Audio(url);
    this.musicElement.loop = true;
    this.musicElement.volume = 0.3;
  }

  toggleMusic(enabled: boolean): void {
    this.musicEnabled = enabled;
    if (enabled) {
      this.musicElement?.play().catch(() => {});
    } else {
      this.musicElement?.pause();
    }
  }

  toggleSFX(enabled: boolean): void {
    this.sfxEnabled = enabled;
  }
}

export const audioManager = new AudioManager();
